import { render, staticRenderFns } from "./PAMM.vue?vue&type=template&id=6db61a2e&"
import script from "./PAMM.vue?vue&type=script&lang=js&"
export * from "./PAMM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports